import type React from "react"
import { X } from "lucide-react"

type CrudBulkSelectionBarProps = {
  selectedCount: number
  entityLabel: string
  onClear?: () => void
  children: React.ReactNode
  className?: string
}

export function CrudBulkSelectionBar({
  selectedCount,
  entityLabel,
  onClear,
  children,
  className = "",
}: CrudBulkSelectionBarProps) {
  if (selectedCount <= 0) return null

  const countLabel = `${selectedCount} ${entityLabel}${selectedCount > 1 ? "s" : ""} selected`

  return (
    <>
      <div
        className={`mb-3 hidden flex-wrap items-center justify-between gap-3 rounded-lg border border-electric-blue/20 bg-electric-blue/5 p-3 md:flex ${className}`}
      >
        <span className="text-sm font-medium text-deep-ocean">{countLabel}</span>
        <div className="flex flex-wrap gap-2">{children}</div>
      </div>

      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-gray/15 bg-white p-3 shadow-lg md:hidden pb-[max(0.75rem,env(safe-area-inset-bottom))]">
        <div className="mb-2 flex items-center justify-between gap-2">
          <span className="text-xs font-medium text-deep-ocean">{countLabel}</span>
          {onClear ? (
            <button
              type="button"
              onClick={onClear}
              className="inline-flex h-8 items-center gap-1 rounded-md px-2 text-xs font-medium text-slate-gray hover:bg-slate-100"
            >
              <X className="h-3.5 w-3.5" />
              Clear
            </button>
          ) : null}
        </div>
        <div className="flex flex-wrap gap-2 [&_button]:h-10 [&_button]:text-sm">{children}</div>
      </div>
    </>
  )
}
